module.exports = __webpack_public_path__ + "static/40c07b.jpg";